import React from 'react'
import {Alert, Button, Col, message, Row, Spin} from 'antd'
import {ExcelRenderer} from 'react-excel-renderer'
import {FileTextFilled, InboxOutlined} from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import Modal from "antd/es/modal/Modal";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ImportExcelSheets extends React.Component {
    constructor(props) {
        super(props)
        this.DEFAULT_FILENAME = 'Sheets'
        this.state = {
            fileName: this.DEFAULT_FILENAME,
            dataset: [],
            columns: [],
            errorFormat: false,
            errorFormatObject: {}
        }
    }

    componentDidMount() {
        this.setState({
            fileName: this.props.fileName ?? this.DEFAULT_FILENAME,
            columns: this.props.columns ?? [],
            dataset: this.props.dataset ?? [],
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                fileName: this.props.fileName ?? this.DEFAULT_FILENAME,
                columns: this.props.columns ?? [],
                dataset: this.props.dataset ?? [],
            })
        }
    }

    handleUpload = (f, onSuccess, onError) => {
        this.setState({
                errorFormat: false,
                errorFormatObject: {}
            }
        )
        ExcelRenderer(f, (err, resp) => {
            if (err) {
                message.error(err).then((r) => {
                })
            } else {
                let rows = resp.rows.filter((v) => {
                    return v.length !== 0
                })
                const titles = rows[0]
                let data = this.state.columns;
                if (data.length !== titles.length) {
                    message.error("Wrong template format").then((r) => {})
                    onError()
                    this.setState({
                        errorFormat: true,
                        errorFormatObject: {
                            titles: titles,
                            data: data
                        }
                    })
                    return
                }
                const columns = titles.map((item, idx) => {
                    return {
                        title: item,
                        dataIndex: data[idx].dataIndex,
                        key: data[idx].key,
                        render: (text, record, index) => (
                            <span
                                style={{
                                    display: 'block',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}>
                            {text}
                          </span>
                        )
                    }
                })
                rows.shift()
                if (this.props.onDataLoaded) {
                    this.props.onDataLoaded(columns, rows)
                }
            }
            onSuccess()
        })
    }

    customRequestSheet = (options) => {
        const {onSuccess, onError, file} = options
        this.handleUpload(file, onSuccess, onError)
    }

    render() {
        function showResultLayout(instance) {
            return (
                <Modal
                    title='Update Progress'
                    centered
                    visible={instance.state.progressVisible}
                    onCancel={() => {
                        instance.setState({progressVisible: false})
                    }}
                    footer={null}
                    width={1000}
                >
                    <div style={{overflow: 'auto', height: 400}}>
                        <p>Update {instance.state.totalPromiseNum} artwork pieces</p>
                        <Spin size='large' style={{marginTop: 20}} spinning={instance.state.loading}>
                            {instance.state.promiseResults}
                        </Spin>
                    </div>
                </Modal>
            )
        }

        const getFileName = () => {
            let today = new Date().toISOString().slice(0, 10)
            return this.state.fileName + '_' + today
        }

        const getErrorFormatLayout = () => {
            if (this.state.errorFormat) {
                const required = this.state.errorFormatObject.data.map((d) => (d.title)).join(",")
                const uploaded = this.state.errorFormatObject.titles.join(",")
                return <Row>
                    <Alert
                        message="Required & Uploaded Format Mismatched"
                        showIcon
                        type="error"
                    />
                    <Col span={24}>
                        <h4>Accepted format (total columns: {this.state.errorFormatObject.data.length}):</h4>
                        <p>{required}</p>
                        <p></p>
                        <h4>Your upload format (total columns: {this.state.errorFormatObject.titles.length}):</h4>
                        <p>{uploaded}</p>
                    </Col>
                </Row>
            }
        }

        return (
            <Row>
                <Modal open={this.state.errorFormat} destroyOnClose={true} onCancel={() => {
                    this.setState({
                        errorFormat: false
                    })
                }} onOk={() => {
                    this.setState({
                        errorFormat: false
                    })
                }}>
                    {getErrorFormatLayout()}
                </Modal>
                <Col span={24}>
                    <ExcelFile
                        filename={getFileName()}
                        element={
                            <Button type={'link'} target={'_blank'} icon={<FileTextFilled/>}>
                                Download the excel sheet template
                            </Button>
                        }
                    >
                        <ExcelSheet data={[]} name='data'>
                            {this.state.columns?.map((column) => {
                                return (
                                    <ExcelColumn label={column.title} value={""} widthPx={column.width}
                                                 style={column.style}/>
                                )
                            })}
                        </ExcelSheet>
                    </ExcelFile>
                </Col>
                <Col span={24}>
                    <Dragger maxCount={1} name='fileexcel' customRequest={this.customRequestSheet}
                             onChange={this.onChange}>
                        <p className='ant-upload-drag-icon'>
                            <InboxOutlined/>
                        </p>
                        <p className='ant-upload-text' style={{paddingLeft: 24, paddingRight: 24}}>Click or drag Excel
                            Sheet
                            to this area to upload</p>
                    </Dragger>
                </Col>
            </Row>
        )
    }
}

export default ImportExcelSheets
